import React, { useState, useEffect, useRef } from 'react';
import ProfileRow from './ProfileRow';
import CanvasItem from './avwapp.chart';
import { fetchData } from './service/avwapp.service';
import { host } from './env';





type GainersProps = {
    
};

const Gainers: React.FC<GainersProps> = ({}) => {

    const [gainersData, setGainersData] = useState<any>({});
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
 

    useEffect(() => {
    handleGainers()
  }, []); 


  const fetchGainersFromApi = async () => {
    try {
      const result = await fetchData(`${host}/current-stock-gainers`);
      setGainersData(result);
    } catch (err) {
      setError('Failed to fetch gainers');
      console.log('err', err);
    } finally {
    
    }
  };

  const handleGainers = async () => {
    fetchGainersFromApi();
  };

  return (

     <div>

        <h3 className="avwapp-subtitle">
          Top Gainers of the day (No biotechs)
        </h3>   
          {Object.keys(gainersData).map(function (ticker, index) {
            const chartObj = gainersData[ticker];
            return (
              <div className="stock">
                
                <ProfileRow profile={chartObj.profile} ticker={ticker} symbolInfo={chartObj.symbolInfo} />

                <div className="row">
                  <div className="column">
                    <p> 6 month daily, 21 SDMA </p>

                    <CanvasItem
                      matchViewportWidth = {true}
                      width={400}
                      height={400}
                      index={index}
                      ticker={ticker}
                      title={'6 month daily'}
                      onPriceChange={price => {}}
                      chartData={chartObj.daily}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        
    </div>
  );
};





export default Gainers;